import React, { FC, ReactElement } from 'react';
import { SaleBadge as UiKitSaleBadge } from '@westwing/ui-kit/ProductBadges';
import { useSelector } from 'react-redux';
import StateInterface from '../../redux/types';

export enum ProductSalesType {
    BLACK_FRIDAY = 'BLACK_FRIDAY',
    CYBER_MONDAY = 'CYBER_MONDAY',
    NO_SALES = 'NO_SALES',
}

type BadgeColours = { [key in keyof typeof ProductSalesType]: string };

const useBadgeColors = () => {
    const colours: BadgeColours = {
        BLACK_FRIDAY: useSelector<StateInterface, string>(
            state => state.configurations.specialSales.blackFridayBadgeColor
        ),
        CYBER_MONDAY: useSelector<StateInterface, string>(
            state => state.configurations.specialSales.cyberMondayBadgeColor
        ),
        NO_SALES: '',
    };

    return colours;
};

// eslint-disable-next-line import/prefer-default-export
export const SaleBadge: FC<{ className?: string; productSalesTypes: ProductSalesType }> = ({
    className,
    productSalesTypes,
}): ReactElement => {
    const colours = useBadgeColors();

    return (
        <UiKitSaleBadge color={colours[productSalesTypes]} className={className} data-sales-type={productSalesTypes} />
    );
};
